import styled from "styled-components"


const SynergyTitle = styled.div`
    font-size: 0.75rem;
    font-family: 'Pretendard Variable';
    color: black;
    font-weight: 400;
    padding: 0.125rem 0;
`

const SynergyContentBase = styled.div`
    font-size: 0.75rem; 
    font-family: 'Pretendard Variable';
    font-weight: 800;
    padding: 0.125rem 0; 
`

const SynergyContentPositive = styled(SynergyContentBase)`
    color: #316BFF;
`

const SynergyContentNegative = styled(SynergyContentBase)`
    color: #FF3131;
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: end;
`

const ContentContainer = styled.div`
    display: flex;
    min-width: 8.125rem;
    flex-direction: column;
    align-items: start;
`

const SynergyContainer = styled.div`
    display: flex;
    flex-direction: row;
`


// 4개의 아이템이 있는 배열 필요: synergies 
// 아이템이 가지는 속성: condition, currentNumber, targetNumber, result, isPositive
export default function SynergyDisplay({synergies}){
    return(
        <SynergyContainer>
            <TitleContainer>

                {synergies.map((item, index) => (
                    <SynergyTitle>{item.condition} : 현재 {item.currentNumber}장</SynergyTitle>
                ))}

                {/* <SynergyTitle>라이브, 시즌, 국가대표, 올스타 3장 이상 : 현재 0장</SynergyTitle>
                <SynergyTitle>임팩트 7장 이상 : 현재 0장</SynergyTitle>
                <SynergyTitle>시그니쳐 6장 이상 : 현재 0장</SynergyTitle>
                <SynergyTitle>골든글러브, 올스타 4장 이하 : 현재 0장</SynergyTitle> */}
            </TitleContainer>

            <div style={{width:'1.25rem'}}></div>

            <ContentContainer>
                {synergies.map((item, index) => (
                    item.isPositive ?
                    (<SynergyContentPositive key={index}>{item.result}</SynergyContentPositive>)
                    :
                    (<SynergyContentNegative key={index}>{item.result}</SynergyContentNegative>)
                ))}

                {/* <SynergyContent>모든 선수 모든 능력치 +1</SynergyContent>
                <SynergyContent>없음</SynergyContent>
                <SynergyContent>모든 투수 능력치 +1</SynergyContent>
                <SynergyContent>없음</SynergyContent> */}
            </ContentContainer>
        </SynergyContainer>
    )
}